import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class ImageTypesService {
  constructor(private http: HttpClient) {}

  public fetchImageTypes(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/imageTypes`
    return this.http.post(url, params)
  }
  public fetchImageType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/imageType/${id}`
    return this.http.get(url, {})
  }

  public deleteImageType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/imageType/${id}`
    return this.http.delete(url)
  }

  public createImageType(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/imageType`
    return this.http.post(url, params)
  }

  public updateImageType(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/imageType/${id}`
    return this.http.put(url, params)
  }
}
